import React from 'react'
import { useSelector } from 'react-redux'
import { message, Checkbox as AntCheckbox } from 'antd'
import useAction from 'utils/useAction'
import { actions as adPackageActions } from 'domains/adPackages'
import { getShopAdPackages } from 'domains/shops/selectors'

const StatusCheckbox = ({ id }) => {
  const adPackages = useSelector(getShopAdPackages)
  const adPackage = adPackages.find((adPackage) => adPackage.id === id)
  const updateAdPackage = useAction(adPackageActions.updateAdPackageRequest)

  return (
    <AntCheckbox
      checked={adPackage?.attributes?.status === 'active'}
      onChange={async (e) => {
        let status = e.target.checked ? 'active' : 'closed'

        await updateAdPackage({ id, status: status })

        let packageMessage = `Ad Package Status set to ${status}`

        if (status === 'active') {
          message.success(packageMessage)
        } else {
          message.error(packageMessage)
        }
      }}
    />
  )
}

export default StatusCheckbox
